import { useCountUp } from "../lib/useCountUp.js";

interface Props {
  score: number;
  run: boolean;
}

export function StatBar({ score, run }: Props) {
  const val = useCountUp(score, run, 1100);
  const tone = score < 40 ? "var(--red)" : score < 65 ? "var(--yellow)" : "var(--green)";
  return (
    <div className="meter">
      <div className="meter-track">
        <div className="meter-fill" style={{ width: run ? `${val}%` : "0%", background: tone }} />
      </div>
      <span className="meter-num">{val}</span>
    </div>
  );
}
